export default __webpack_public_path__ + "static/media/contador.c48ac79d.jpg";